import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_krhzdcamfc: FaireCollectionEntity = {
  token: "pbc_krhzdcamfc",
  type: "collection",
  name: "Halloween 👻👻",
  heroImageUrl:
    "https://cdn.faire.com/fastly/75e4eb0a9ebfa60664c7787c718d2f2ddff03bf7e62e5551b91e44fb9a81580b.jpeg",
  itemCount: 81,
  description:
    'Say "boo" in style with our new designs for Halloween! From adorable pumpkins and friendly ghosts to spooky-cute prints, our festive collection is made for trick-or-treating, pumpkin patch adventures, and all the magical moments in between. ',
  brandToken: "b_gro99lye",
  // itemCount above is the collection's real total (81) — `import-collections`
  // can't fetch full membership (swallowed 401, see the framework SKILL.md),
  // so this is a curated subset of real, individually-imported product
  // tokens (per Ryan), not the full 81.
  productTokens: [
    "p_gehjvh9rv2",
    "p_jvkgzpkqkg",
    "p_4k7nd38ket",
    "p_t3xyjycqp3",
    "p_rmqsym6mvr",
    "p_yw93t3q98r",
  ],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:36.951Z",
    importedBy: "entity-db-import-collections",
  },
};
